import React from 'react';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';
import styled from 'styled-components';
import A from '../Basic/A';
import AnchorStyle from '../Basic/AnchorStyle';
import ContainerFull from '../Basic/ContainerFull';
import Desc from '../Basic/Desc';
import Heading from '../Basic/Heading';
import Tables from './Tables';
configureAnchors({ offset: -30 });

const Wrap = styled.div`
	position: relative;
`;

export default props => (
	<ContainerFull>
		<Wrap>
			<ScrollableAnchor
				id={
					props.id
						? props.id
						: Math.random()
								.toString(36)
								.substring(5)
				}
			>
				<span />
			</ScrollableAnchor>
			<Heading>Get Started Now!</Heading>
			<Desc>
				As developers, we spend over{' '}
				<strong>200 Hrs/month with our code editors — it's only fair to learn your next editor deeply</strong>.
				This course will save you 15-20 hours every month. I've poured my dev-heart out in this course.{' '}
				<strong>Spent 1,000+ hours so that you don't have to</strong>. From building a custom course platform to
				audio/video setup. I assure you this ridiculous hard work is <strong>worth its weight in gold</strong>.
				By buying this course, you're enabling me; a full-time open source dev to build more free/premium
				courses.
				<br />
				Got questions? <AnchorStyle href="#FAQ">I got answers</AnchorStyle> or just tweet at{' '}
				<A href="https://twitter.com/MrAhmadAwais/">@MrAhmadAwais →</A>
			</Desc>
			<Tables />
		</Wrap>
	</ContainerFull>
);
